/** @jsx jsx */
import { jsx } from 'theme-ui'
import * as React from 'react'
import { useEntity, useMeta } from '../helpers/selectors'
import { Link } from '../helpers/react'
import { Palette } from '../../utils/palette'
import { TruArrow } from '@uswitch/spark-icons/tru'

const baseStyle = {
  outer: {
    variant: 'styles.h4',

    display: 'flex',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: 'grey-05',
  },
  text: {
    flexGrow: 1,
  },
  icon: {
    flexShrink: 0,
    pl: 'md',
  },
}

const variantStyles = {
  default: {
    outer: {
      ...baseStyle.outer,

      alignItems: 'center',
      borderWidth: 0,
      borderLeftWidth: 6,
      borderStyle: 'solid',
      borderColor: 'primary',
      pl: 'md',
      pr: 'sm',
      pt: 'sm',
      pb: 'base',
      '&:hover': {
        textDecoration: 'underline',
        color: 'anchor-hover',
        backgroundColor: 'grey-10',
      },
      my: 'md',
    },
    text: {
      ...baseStyle.text,
    },
    icon: {
      ...baseStyle.icon,
    },
  },
  cupcard: {
    outer: {
      ...baseStyle.outer,
      padding: 'md',
      flexDirection: ['row', 'column'],
      alignItems: ['center', 'stretch'],
      height: [null, 176],
      '&:hover': {
        boxShadow: 'card',
        opacity: 1,
      },
    },
    text: {
      ...baseStyle.text,
      mb: [null, 'md'],
    },
    icon: {
      ...baseStyle.icon,
      alignSelf: [null, 'flex-end'],
    },
  },
}

const getStyle = (variant) => (variant ? variantStyles[variant] : variantStyles.default)

const ReadMoreCard = ({ text, href, className, variant }) => {
  const style = getStyle(variant)

  return (
    <Link href={href} sx={{ ...style.outer, svg: { fill: 'currentColor' } }} className={className}>
      <div sx={style.text}>{text}</div>
      <div sx={style.icon}>
        <TruArrow color={'primary'} sx={{ transform: 'rotate(0.25turn)' }} size={18} />
      </div>
    </Link>
  )
}

const contentfulVariantMapping = {
  'Read More': 'default',
  Cupcard: 'cupcard',
}

const ConnectedReadMoreCard = ({ displayText, url, variant, ...props }) => {
  const href = useEntity(url).url
  const homePath = useMeta(['breadcrumbs', 'homePath'], '')

  return (
    <ReadMoreCard
      text={displayText}
      href={href[0] === '/' ? href : `${homePath}/${href}`}
      variant={contentfulVariantMapping[variant]}
      {...props}
    />
  )
}

export default (props) => (
  <Palette as={ConnectedReadMoreCard} px={{ backgroundColor: 'featureColor' }} {...props} />
)
